import React from "react";

const HeaderTable = ({headers}) => {
    return (
        <thead>
        <tr className="bg-blue-100">
            {headers.map((header, index) => {
                return (
                    <th key={index} className="py-3 px-6 text-left font-semibold text-blue-600 uppercase tracking-wider">
                        {header}
                    </th>
                )
            })}
        </tr>
        </thead>
    )
}

export default HeaderTable;